import Css from "./style.module.scss";

import * as Icons from "@phosphor-icons/react";
import { getTextsData } from "selectors/texts";
import { useSelector } from "react-redux";
import DragAndDropArea from "nlib/ui/DragAndDropArea";
import Platforms from "utils/Platforms";
import React, { useMemo } from "react";

const DropArea = ({ extensions = [], showAccepted = true, hint, ...restProps }) => {
  const { uiTexts, messages } = useSelector(getTextsData);

  const acceptedExtensions = useMemo(() => {
    return extensions.map((extension) => extension.replace(/^\./, "").toUpperCase()).join(", ");
  }, [extensions]);

  return (
    <DragAndDropArea {...restProps}>
      {({ accepted }) => (
        <div className={Css.dropArea}>
          {accepted.length && showAccepted
            ? (
              <div className={Css.accepted}>
                <Icons.FilePlus />
                {(accepted.length > 1) ? `${uiTexts.filesSelected}: ${accepted.length}` : accepted[0].name}
              </div>
            )
            : (
              <>
                <div className={Css.text}>
                  <Icons.FileText />
                  <span>{Platforms.checkIsTouchDevice() ? messages.fileUploadDescription : messages.fileDropDescription}</span>
                </div>
                {!!extensions.length && (
                  <span className={Css.formats}>
                    <span>{uiTexts.supportedFormats}:</span>
                    <div className={Css.extensions}>
                      {extensions.length ? acceptedExtensions : uiTexts.any.toLowerCase()}
                    </div>
                  </span>
                )}
                {hint && <span className={Css.formats}>{hint}</span>}
              </>
            )}
        </div>
      )}
    </DragAndDropArea>
  );
};

export default React.memo(DropArea);
